import { render } from "./editSecondarystudent.vue?vue&type=template&id=2109fd45&scoped=true"
import script from "./editSecondarystudent.vue?vue&type=script&lang=js"
export * from "./editSecondarystudent.vue?vue&type=script&lang=js"

import "./editSecondarystudent.vue?vue&type=style&index=0&id=2109fd45&scoped=true&lang=css"

import exportComponent from "/mnt/extra-storage/2026_cdf/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2109fd45"]])

export default __exports__